let app = {

   parallaxElement: null,
   parallaxElementPosition: 0,

   init() {
      this.parallaxElement = document.querySelector('.header-front img')   
      if (this.parallaxElement) {      
         this.parallaxElementPosition = window.getComputedStyle(this.parallaxElement).getPropertyValue('bottom');
           window.requestAnimationFrame(()=>{this.parallax()});
           window.addEventListener("scroll", (event) => {
              window.requestAnimationFrame(()=>{this.parallax()});
           })
           window.addEventListener("resize", (event) => {
            window.requestAnimationFrame(()=>{this.parallax()});
         }, false);
      }
   },

   parallax() {
      this.parallaxElement.style.bottom = "calc(" + this.parallaxElementPosition + " - " + window.scrollY / 4 + "px)";
   },
}



setTimeout(() => {
   app.init()
}, 0)
